import axios from "axios"
import { baseURL } from "../config/api";

export const getAdditionalCharges = (tenantId: string) => {
    return getFetch("additionalCharge", tenantId);
}

export const getAdditionalCharge = (primaryKey: string, tenantId: string) => {
    return getFetch(`additionalCharge/${primaryKey}`, tenantId);
}

export const getExtras = (branchId: string, vehicleClassId: string, tenantId: string) => {
    return getFetch(`extra/customer/GetExtrasWithCategoryForCustomer/${branchId}/${vehicleClassId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}